/**
 * EllipseOutlineIcon — sanitized from `assets/newSvg/ellipse-outline.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function EllipseOutlineIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M6,2 C4.89543,2 4,2.89543 4,4 L4,20 C4,21.1046 4.89543,22 6,22 L17,22 C18.6569,22 20,20.6569 20,19 L20,5 C20,3.34315 18.6569,2 17,2 L16,2 L16,11.7929 C16,12.2383 15.4614,12.4614 15.1464,12.1464 L13.3536,10.3536 C13.1583,10.1583 12.8417,10.1583 12.6464,10.3536 L10.8536,12.1464 C10.5386,12.4614 10,12.2383 10,11.7929 L10,2 L6,2 Z"
        fill={color}
      />
    </Svg>
  );
}

export default EllipseOutlineIcon;
